import { createSlice } from "@reduxjs/toolkit";
import { faqArticlesAPI } from "../../../api/publicApi";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const faqArticlesSlice = createSlice({
  name: "faqArticles",
  initialState: data,
  reducers: {
    faqArticlesSlice(state) {
      state.isLoading = false;
    },
    faqArticlesSliceSuccess(state, action) {
      state.isLoading = true;
      state.data = action.payload;
      state.message = null;
    },
    faqArticlesSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
    },
    faqArticlesSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});

export const faqArticlesHandler = () => async (dispatch: any) => {
  try {
    dispatch(faqArticlesAction.faqArticlesSlice());
    const response: any = await faqArticlesAPI();
    dispatch(faqArticlesAction.faqArticlesSliceSuccess(response));
  } catch (e: any) {
    dispatch(faqArticlesAction.faqArticlesSliceFailure(e?.response?.data?.message));
    dispatch(faqArticlesAction.faqArticlesSliceReset());
  }
};
export default faqArticlesSlice.reducer;
export const faqArticlesAction = faqArticlesSlice.actions;
